document.addEventListener('DOMContentLoaded', function() {
  const dropHintPopup = document.getElementById('drop-hint-popup');
  const openTrigger = document.querySelector('.open-drop_hint_button__trigger');
  const closeButton = document.querySelector('.drop-hint-popup__close');
  const overlay = document.querySelector('.drop-hint-popup__overlay');


  // Mở popup khi click vào trigger button
  if (openTrigger) {
    openTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (dropHintPopup) {
        dropHintPopup.classList.add('active');
      }
    });
  }

  // Đóng popup khi click vào nút close
  if (closeButton) {
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi click vào overlay (ra ngoài popup)
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi click ra ngoài popup content
  if (dropHintPopup) {
    dropHintPopup.addEventListener('click', function(e) {
      // Chỉ đóng nếu click vào chính popup container, không phải popup content
      if (e.target === dropHintPopup) {
        dropHintPopup.classList.remove('active');
      }
    });
  }

  // Đóng popup khi nhấn phím ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && dropHintPopup && dropHintPopup.classList.contains('active')) {
      dropHintPopup.classList.remove('active');
    }
  });




    // Khởi tạo giá trị mặc định cho hint names
    const hintRecipientName = document.getElementById('hintRecipientName');
    const hintSenderName = document.getElementById('hintSenderName');
    let recipientInput = null;
    let senderInput = null;

    // Hàm tìm kiếm input fields từ Powerful Form Builder
    function findInputFields() {
        // Thử tìm theo ID cụ thể
      recipientInput = document.getElementById('input_6_1');
      senderInput = document.getElementById('input_6_5');

        // Nếu tìm thấy, gắn event listeners
        if (recipientInput && !recipientInput.hasAttribute('data-hint-listener')) {
            recipientInput.setAttribute('data-hint-listener', 'true');
            recipientInput.addEventListener('input', updateRecipientName);
            recipientInput.addEventListener('keyup', updateRecipientName);
            recipientInput.addEventListener('change', updateRecipientName);
        }

        if (senderInput && !senderInput.hasAttribute('data-hint-listener')) {
            senderInput.setAttribute('data-hint-listener', 'true');
            senderInput.addEventListener('input', updateSenderName);
            senderInput.addEventListener('keyup', updateSenderName);
            senderInput.addEventListener('change', updateSenderName);
        }
    }

    // Hàm cập nhật tên người nhận
    function updateRecipientName() {
        if (hintRecipientName && recipientInput) {
            const value = recipientInput.value.trim();
            hintRecipientName.textContent = value || '_________';
        }
    }

    // Hàm cập nhật tên người gửi
    function updateSenderName() {
        if (hintSenderName && senderInput) {
            const value = senderInput.value.trim();
            hintSenderName.textContent = value || '_________';
        }
    }

    // MutationObserver để theo dõi khi form được render
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Kiểm tra nếu có input fields mới được thêm
                setTimeout(findInputFields, 100);
            }
        });
    });

    // Bắt đầu observe
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Tìm input fields ngay khi load
    findInputFields();

});